import React, { useContext } from 'react';
import FilterSelectContainer from './FilterSelectContainer';
import DiscoveryContext from '../../../../contexts/discoveryContext/contextV2';
import { filterContainer } from './styles.module.css';

const CategorySearchFilterComponent = ({
  isOpen,
  onClose,
  onToggle,
  filterComponent: FilterComponent,
  filterComponentProps,
  valueComponent: ValueComponent,
  valueComponentProps,
  modalTitle,
  isMobile,
  defaultFilters,
}) => {
  const { pushHistory } = useContext(DiscoveryContext);
  const filterComponentPropsWithClose = {
    onClose,
    ...filterComponentProps,
  };

  const clearFilter = (event) => {
    if (event) {
      event.stopPropagation();
    }

    if (defaultFilters) {
      pushHistory(defaultFilters);
    }
  };

  return (
    <div className={filterContainer}>
      {/* Value Component is refactored to include a Button */}
      <ValueComponent
        {...valueComponentProps}
        onClick={onToggle}
        modalOpen={isOpen}
        clearFilter={clearFilter}
      />
      {isOpen && (
        <FilterSelectContainer
          isMobile={isMobile}
          modalTitle={modalTitle}
          FilterComponent={FilterComponent}
          onClose={onClose}
          filterComponentProps={filterComponentPropsWithClose}
          defaultFilters={defaultFilters}
        />
      )}
    </div>
  );
};

CategorySearchFilterComponent.propTypes = {};

CategorySearchFilterComponent.defaultProps = {
  filterComponent: () => <div>Filter Component</div>,
  valueComponent: () => <div>Value</div>,
};

export default CategorySearchFilterComponent;
